import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  InputType,
  ValidationRule,
  FlexDirection,
} from "../services/types/ComponentTypes";

export const screen_123_add_customer: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    title: "Customers",
    style: {},
    childComponents: [
      {
        componentType: LayoutTypes.FORM,
        Name: "Customer_Add",
        TableName: "customer_details",
        columnNumber: "m1 t1 w3",
        style: {
          padding: 10,
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
        },
        childComponents: [
          {
            componentType: ComponentType.TEXT_FIELD,
            name: "txt_code_number",
            label: "Code",
            placeholder: "Will be auto generated...",
            required: false,
            inputType: InputType.TEXT,
            disabled: true,
            Json_Attribute: "code_no",
            AutoPopulate: true,
            AutoPopulate_format: "CUST_[******]",
          },
          {
            componentType: ComponentType.TEXT_FIELD,
            name: "txt_customer_name",
            label: "Customer name",
            placeholder: "",
            required: true,
            inputType: InputType.TEXT,
            Json_Attribute: "customername",
            validation: [
              {
                rule: ValidationRule.REQUIRED,
                message: "Customer name is required",
              },
              // {
              //   rule: ValidationRule.PATTERN,
              //   value: "^[A-Za-z ]+$",
              //   message: "Only alphabets and spaces are allowed",
              // },
            ],
          },
          {
            componentType: ComponentType.SEARCHABLE_DROPDOWN,
            name: "s_select_customertype",
            label: "Customer type",
            placeholder: "",
            required: true,
            lookupName: "customer_type",
            options: [],
            searchable: true,
            clearable: true,
            Json_Attribute: "customertype",
          },
          {
            componentType: ComponentType.TEXT_FIELD,
            name: "txt_phone",
            label: "Phone",
            placeholder: "",
            required: true,
            inputType: InputType.PHONE,
            Json_Attribute: "phone",
            validation: [
              {
                rule: ValidationRule.PATTERN,
                value: "^[0-9]+$",
                message: "Only numbers are allowed",
              },
            ],
          },
          {
            componentType: ComponentType.TEXT_FIELD,
            name: "txt_mobile",
            label: "Mobile",
            placeholder: "",
            required: true,
            inputType: InputType.PHONE,
            Json_Attribute: "mobile",
            validation: [
              {
                rule: ValidationRule.PATTERN,
                value: "^[0-9]+$",
                message: "Only numbers are allowed",
              },

            ],
          },
          {
            componentType: ComponentType.TEXT_FIELD,
            name: "txt_email",
            label: "Email",
            placeholder: "",
            required: false,
            inputType: InputType.TEXT,
            Json_Attribute: "email",
            validation: [
              {
                rule: ValidationRule.PATTERN,
                value: "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$",
                message: "Invalid email format",
              },
            ],
          },
          {
            componentType: ComponentType.TEXT_FIELD,
            name: "txt_web",
            label: "Web",
            placeholder: "",
            required: false,
            inputType: InputType.URL,
            Json_Attribute: "web",
            validation: [
              {
                rule: ValidationRule.PATTERN,
                value: "^(https?:\\/\\/)?([a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,}(\/.*)?$",
                message: "Invalid URL format",
              },
            ],
          },
          {
            componentType: ComponentType.TEXT_FIELD,
            name: "txt_address",
            label: "Address",
            placeholder: "",
            required: true,
            inputType: InputType.TEXT,
            Json_Attribute: "Address",
          },
          {
            componentType: ComponentType.TEXT_FIELD,
            name: "txt_trn",
            label: "TRN No.",
            placeholder: "",
            required: false,
            inputType: InputType.TEXT,
            Json_Attribute: "trn_no",
          },
          {
            componentType: ComponentType.SEARCHABLE_DROPDOWN,
            name: "s_search_country",
            label: "Country",
            placeholder: "",
            required: false,
            lookupName: "country",
            defaultValue: "United Arab Emirates",
            options: [],
            Json_Attribute: "country",
          },
          {
            componentType: ComponentType.SEARCHABLE_DROPDOWN,
            name: "s_search_states",
            label: "Emirates/State",
            placeholder: "",
            required: false,
            lookupName: "state",
            parentField: "s_search_country",
            options: [],
            searchable: true,
            clearable: true,
            Json_Attribute: "states",
          },
          {
            componentType: ComponentType.SEARCHABLE_DROPDOWN,
            name: "s_search_location",
            label: "City",
            placeholder: "",
            required: false,
            lookupName: "city",
            parentField: "s_search_states",
            options: [],
            searchable: true,
            clearable: true,
            Json_Attribute: "locationpermission",
          },
          {
            componentType: ComponentType.SEARCHABLE_DROPDOWN,
            name: "s_search_salesman",
            label: "Salesman",
            placeholder: "",
            required: false,
            lookupName: "salesman_union",
            options: [],
            searchable: true,
            clearable: true,
            Json_Attribute: "salesman",
          },
          {
            componentType: ComponentType.TEXT_FIELD,
            name: "txt_credit_days",
            label: "Credit days",
            placeholder: "",
            required: false,
            inputType: InputType.NUMBER,
            Json_Attribute: "creditdays",
            validation: [
              {
                rule: ValidationRule.PATTERN,
                value: "^(?:0|[1-9][0-9]?|[12][0-9]{2}|3[0-5][0-9]|36[0-5])$",
                message: "Value must be between 0 and 365",
              },
            ],
          },
          {
            componentType: ComponentType.TEXT_FIELD,
            name: "txt_credit_amount",
            label: "Credit amount",
            placeholder: "",
            required: false,
            inputType: InputType.NUMBER,
            Json_Attribute: "creditamount",
          },
          {
            componentType: ComponentType.FILES,
            name: "file_vat_certificate",
            label: "VAT certificate",
            required: false,
            BindValue: "file_vat_certificate",
            Json_Attribute: "vat_certificate_attachment",
            IsVerticalView: true,
          },
          {
            componentType: ComponentType.FILES,
            name: "credit_application_form",
            label: "Credit application form",
            required: false,
            BindValue: "credit_application_form",
            Json_Attribute: "credit_application_form_attachment",
            IsVerticalView: true,
          },
          {
            componentType: ComponentType.FILES,
            name: "file_trade_license",
            label: "Trade license",
            required: false,
            BindValue: "file_trade_license",
            Json_Attribute: "trade_license_attachment",
            IsVerticalView: true,
          },
          {
            componentType: ComponentType.FILES,
            name: "file_others",
            label: "Others",
            required: false,
            BindValue: "file_others",
            Json_Attribute: "Others_attachment",
            IsVerticalView: true,
          },
        ],
      },
      {
        componentType: ComponentType.BUTTON,
        name: "Save",
        onPressAction: "save",
        style: {
          backgroundColor: "#22c55e",
        },
      },
    ],
  },
];
